export default "__VITE_ASSET__fa38ed00__"